import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Edit from '@material-ui/icons/Edit';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
  SvgIcon,
  TableContainer,
  Typography,
  Chip
} from '@material-ui/core';
import { ArrowRight } from 'react-feather';
import { useSelector } from 'react-redux';
import { useToggle } from 'src/hooks';
import { useTheme } from '@material-ui/core';
const SrchSubResults = ({
  subList,
  handleSubSelect,
  showEdit,
  ixSubType,
  selectedSub = ''
}) => {
  const [
    isSubHaveTaxRegName,
    subHaveTaxRegName,
    subDontHaveTaxRegName
  ] = useToggle();
  const { tax, frontEnd } = useSelector(({ bizMeta }) => bizMeta);
  const theme = useTheme();

  const isSort = frontEnd?.subType?.hasOwnProperty('sortBy');
  const sortBy = frontEnd?.subType?.sortBy || 'sub_title';

  useEffect(() => {
    if (
      tax?.customers?.type_id === ixSubType ||
      (tax?.suppliers?.others || [])?.includes(ixSubType) ||
      tax?.suppliers?.type_id === ixSubType
    ) {
      subHaveTaxRegName();
    } else {
      subDontHaveTaxRegName();
    }
  }, [tax, ixSubType]);

  // Only show sSubType if this type is recognized in the settings (tax) either as the main type or as an allowed ‘other’ type.
  const shouldShowSubType = ixSubType => {
    if (!tax) return false;

    return Object.values(tax).some(
      group =>
        group?.type_id === ixSubType ||
        (Array.isArray(group?.others) && group.others.includes(ixSubType))
    );
  };

  if (!subList || (subList.length === 0 && !selectedSub)) return null;

  const tableRow = item => {
    const isSelected =
      selectedSub &&
      (item.sub_id === selectedSub.sub_id || item.ixSub === selectedSub.ixSub);

    return (
      <TableRow
        hover
        key={item.sub_id}
        onClick={() =>
          handleSubSelect({
            ...item,
            caption_source: tax?.caption_source
          })
        }
        style={{
          backgroundColor: isSelected ? 'rgba(25,118,210,0.08)' : undefined,
          borderLeft: isSelected
            ? `4px solid ${theme.palette.primary.main}`
            : '4px solid transparent',
          boxShadow: isSelected ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
          transform: isSelected ? 'scale(1.01)' : 'none',
          transition: 'all 0.15s ease'
        }}
      >
        <TableCell style={{ width: 80 }}>
          <Box display="flex" flexDirection="column">
            <Typography variant="caption" display="block">
              {item.sub_id}
            </Typography>
            <Typography
              variant="caption"
              display="block"
              style={{
                fontWeight: 900
              }}
            >
              {item.RefNo}
            </Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box display="flex" flexDirection="column">
            <Typography variant="body1">
              {isSubHaveTaxRegName
                ? item[tax?.caption_source] ?? item.sub_title
                : item.sub_title}
            </Typography>
            {shouldShowSubType(ixSubType) && (
              <Typography
                variant="body2"
                color="textSecondary"
                display="block"
                style={{ marginTop: 2 }}
              >
                {item.sSubType}
              </Typography>
            )}
            {(() => {
              const parentName = item.sSubParent || '';
              return parentName ? (
                <Typography variant="caption" color="textSecondary">
                  {parentName}
                </Typography>
              ) : null;
            })()}
            {(() => {
              const values = [
                item.sSubLink1,
                item.sSubLink2,
                item.sSubLink3,
                item.sSubLink4,
                item.sSubLink5
              ].filter(v => typeof v === 'string' && v.trim() !== '');
              if (values.length === 0) return null;
              return (
                <Box
                  mt={0.5}
                  display="flex"
                  gridGap={6}
                  flexWrap="nowrap"
                  overflow="auto"
                >
                  {values.map((val, idx) => (
                    <Chip key={idx} label={val} size="small" />
                  ))}
                </Box>
              );
            })()}
          </Box>
        </TableCell>
        <TableCell style={{ flex: 1 }} />
        <TableCell align="right">
          {showEdit && (
            <IconButton
              onClick={event => handleSubSelect(item, event, 'edit')}
              tabIndex={-1}
            >
              <SvgIcon fontSize="small">
                <Edit />
              </SvgIcon>
            </IconButton>
          )}
          <IconButton
            onClick={() => handleSubSelect(item)}
            className="controls"
          >
            <SvgIcon fontSize="small">
              <ArrowRight />
            </SvgIcon>
          </IconButton>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <TableContainer>
      <Table>
        <TableBody>
          {selectedSub &&
            (selectedSub.ixSub || selectedSub.sub_id) &&
            tableRow(selectedSub)}{' '}
          {[...subList]
            .sort((a, b) => {
              if (!isSort) return 0;
              const valA = (a?.[sortBy] ?? '').toString().toLowerCase();
              const valB = (b?.[sortBy] ?? '').toString().toLowerCase();
              return valA.localeCompare(valB);
            })
            .filter(item => item.ixSub !== selectedSub?.ixSub)
            .map(tableRow)}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

SrchSubResults.propTypes = {
  className: PropTypes.string,
  subList: PropTypes.array.isRequired,
  handleSubSelect: PropTypes.func
};

export default SrchSubResults;
